<template>
    <div class="custom-checkbox">
        <input
            class="form-check-input"
            :name="label.split(' ').join('-')"
            :id="label.split(' ').join('-')"
            :checked="checked"
            type="checkbox"
            @change="$emit('change', label)"
        />
        <label :for="label.split(' ').join('-')" tabindex="-1">{{
            label
        }}</label>
    </div>
</template>

<script>
export default {
    props: {
        label: String,
        checked: Boolean,
    },
};
</script>
